export enum DefaultGridButtons {
    filter = 'filter',
    reload = 'reload',
    add = 'add',
    edit = 'edit',
    remove = 'remove',
    view = 'view',
    moveDown = 'moveDown',
    moveUp = 'moveUp',
    copy = 'copy',
    paste = 'paste'
}

export enum ReportGridButtons {
    filter = 'filter',
    reload = 'reload'
}
